import { render, staticRenderFns } from "./move-print.vue?vue&type=template&id=8a7e4834&scoped=true&"
import script from "./move-print.vue?vue&type=script&lang=js&"
export * from "./move-print.vue?vue&type=script&lang=js&"
import style0 from "./move-print.vue?vue&type=style&index=0&id=8a7e4834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7e4834",
  null
  
)

export default component.exports